import { Directive, ElementRef, OnDestroy, AfterViewInit, Inject, PLATFORM_ID } from "@angular/core";
import { TaboolaService } from "./taboola.service";
import { isPlatformBrowser } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Directive({ selector: "[appTaboolaLazy]" })
export class TaboolaLazyDirective implements AfterViewInit, OnDestroy {
  private io?: IntersectionObserver;
  private routerSubscription?: Subscription;

  constructor(
    private el: ElementRef<HTMLElement>,
    private taboola: TaboolaService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Configurar el observer inicial
    this.setupIntersectionObserver();

    // Suscribirse a los cambios de ruta
    this.routerSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // Reiniciar el observer en cada cambio de ruta
      this.io?.disconnect();
      this.setupIntersectionObserver();
    });
  }

  private setupIntersectionObserver(): void {
    this.io = new IntersectionObserver(
      (e) => {
        if (e[0].isIntersecting) {
          this.taboola.renderPlacement();
          this.io?.disconnect();
        }
      },
      { rootMargin: "0px 0px 200px 0px" },
    );
    this.io.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.io?.disconnect();
    this.routerSubscription?.unsubscribe();
  }
}
